import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ILicenca } from 'src/app/shared/api/licencas/licencas.service';
import { IMidia } from 'src/app/shared/api/testes/adm-midias.service';
import { JogadaService } from 'src/app/shared/api/testes/jogada.service';
import { ConstantsWidthHeightMidia } from 'src/app/shared/components/card-midia/card-midia-constants';
import {
    IMAGE_FORMATS,
    VIDEO_FORMATS
} from 'src/app/shared/components/card-midia/image-video-formats.resource';
import { ConstantsRotasDoSistema } from 'src/app/shared/constants/constants-rotas-do-sistema';
import { unformatedStringDateToPortugueseDateString } from 'src/app/shared/functions/data-transform';
import { abrirEmNovaAba } from 'src/app/shared/functions/utils';
import { DialogService } from 'src/app/shared/services/dialog.service';
import { StatusBadgeTipo } from 'src/app/shared/components/status-badge/status-badge.component';

export interface IStatusBadge {
    tipo: StatusBadgeTipo;
    label: string;
    detalhe?: string;
    tooltip?: string;
}

@Component({
    selector: 'card-licenca',
    templateUrl: './card-licenca.component.html',
    styleUrls: ['./card-licenca.component.scss']
})
export class CardLicencaComponent implements OnInit {
    @Input() licenca!: ILicenca;

    // @Output() onIniciarClick = new EventEmitter();

    imageLoaded = false;
    midiaTeste?: IMidia;
    statusBadge: IStatusBadge = { tipo: 'disponivel', label: 'Disponível' };

    constantsWidthHeightMidia = ConstantsWidthHeightMidia;
    imageFormats = IMAGE_FORMATS;
    videoFormats = VIDEO_FORMATS;

    constructor(
        private router: Router,
        private jogadaService: JogadaService,
        private dialog: DialogService
    ) { }

    ngOnInit(): void {
        this.statusBadge = this.calcularStatus();
    }

    private calcularStatus(): IStatusBadge {
        if (this.licenca.data_fim) {
            return { tipo: 'concluido', label: 'Concluído' };
        }

        if (this.exibirCadeado()) {
            const disponivelDe = this.licenca.disponivel_de;
            const temDataFutura = disponivelDe != null && !this.isDataAtualOuAnterior(disponivelDe);
            return {
                tipo: temDataFutura ? 'agendado' : 'bloqueado',
                label: temDataFutura ? 'Agendado' : 'Bloqueado',
                tooltip: temDataFutura && disponivelDe
                    ? `Liberado em ${this.converterData(disponivelDe)}`
                    : 'Ainda não liberado'
            };
        }

        if (this.licenca.data_inicio) {
            return {
                tipo: 'em_andamento',
                label: 'Em andamento',
                detalhe: `${this.licenca.progresso}%`
            };
        }

        return { tipo: 'disponivel', label: 'Disponível' };
    }

    tooltipCadeado() {
        const disponivelDe = this.licenca.disponivel_de;
        if (disponivelDe && !this.isDataAtualOuAnterior(disponivelDe)) {
            return `Liberado em ${this.converterData(disponivelDe)}`;
        }
        return 'Ainda não liberado';
    }

    converterData(data: string) {
        if (data == null) return '';
        return unformatedStringDateToPortugueseDateString(data);
    }

    loadImage() {
        this.imageLoaded = true;
    }

    iniciar() {
        this.iniciarJogadaClick(this.licenca);
    }

    iniciarJogadaClick = (licenca: ILicenca) => {
        if (licenca.data_inicio) {
            this.iniciarJogada(licenca);
            return;
        }

        this.dialog
            .confirm('Confirmar', 'Deseja realmente iniciar o jogo agora?')
            .subscribe((confirmado) => {
                if (confirmado) {
                    this.iniciarJogada(licenca);
                }
            });
    };

    iniciarJogada(licenca: ILicenca) {
        this.jogadaService.getRodadaAtual(licenca.uuid).subscribe({
            next: (response) => {
                this.goToJogada(licenca.uuid);
            },
            error: () => {
                this.jogadaService.iniciarJogada(licenca.uuid).subscribe({
                    next: (response) => {
                        this.goToJogada(licenca.uuid);
                    }
                });
            }
        });
    }

    private goToJogada(id: string) {
        this.router.navigate([
            ConstantsRotasDoSistema.DEFAULT_PATH + ConstantsRotasDoSistema.PLAY + `/${id}`
        ]);
    }

    relatorio() {
        const url = ConstantsRotasDoSistema.RELATORIOS + '/' + this.licenca.uuid;
        // this.router.navigate([url]);
        abrirEmNovaAba(url);
    }

    recomendacoes() {
        const url = ConstantsRotasDoSistema.RECOMENDACOES + '/' + this.licenca.uuid;
        this.router.navigate([url]);
    }

    getFileFormatFromUrl(url: string) {
        // Remover parâmetros da URL (se houver)
        const cleanUrl = url.split('?')[0];

        // Extrair a extensão do arquivo
        const extension = cleanUrl.split('.').pop();

        return extension?.toLowerCase();
    }

    isDataAtualOuAnterior(dataString1: string) {
        const today = new Date();
        today.setHours(0, 0, 0, 0); // Zera horas, minutos, segundos e milissegundos para comparação apenas da data

        const inputDate = new Date(dataString1);
        inputDate.setHours(0, 0, 0, 0);

        return inputDate <= today; // Retorna true se for hoje ou uma data anterior
    }

    podeIniciarLicenca() {
        return (
            this.licenca.data_fim == null &&
            this.licenca.liberado &&
            (this.licenca.disponivel_de == null ||
                this.isDataAtualOuAnterior(this.licenca.disponivel_de))
        );
    }

    exibirCadeado() {
        return (
            !this.licenca.liberado ||
            !(this.licenca.disponivel_de == null ||
                this.isDataAtualOuAnterior(this.licenca.disponivel_de))
        )
    }
}
